import React, { forwardRef } from 'react';

export default function CheckBox ({ name, checkBoxName, ...rest }) {
    return (
            <label className="checkbox"><input type="checkbox" name={name} {...rest} /><span></span>{checkBoxName}</label>
    )
}